import PsychologistsList from "./PsychologistsList/PsychologistsList.vue";
import UserService from "@/services/UserService";

export default {
  name: "Psychologists",
  components: {
    PsychologistsList,
  },
  data() {
    return {
      dateFilter: "",
      customDateFrom: "",
      customDateTo: "",
      dateFilterOptions: [
        { id: "", title: "Todas as datas" },
        { id: "hoje", title: "Hoje" },
        { id: "ontem", title: "Ontem" },
        { id: "ultimos_30_dias", title: "Últimos 30 dias" },
      ],
      // Pills (single-select). countKey casa com a chave do endpoint de counts.
      pills: [
        { id: "todos", name: "Todos", countKey: "all", filters: {} },
        {
          id: "aprovados",
          name: "Aprovados",
          countKey: "approved",
          filters: { approved: "1" },
        },
        {
          id: "reprovados",
          name: "Não aprovados",
          countKey: "not_approved",
          filters: { approved: "0" },
        },
        {
          id: "online",
          name: "Online",
          countKey: "online",
          filters: { online: "1" },
        },
        {
          id: "com_sessao",
          name: "Com sessão",
          countKey: "with_appointment",
          filters: { has_appointment: "1" },
        },
        {
          id: "pagantes",
          name: "Pagantes",
          countKey: "paying",
          filters: { subscriber_only: "1" },
        },
        {
          id: "plus",
          name: "Psiapp+",
          countKey: "plan_plus",
          filters: { plan_slug: UserService.PlanSlugs.plus },
        },
        {
          id: "basico",
          name: "Plano Básico",
          countKey: "plan_basic",
          filters: { plan_slug: UserService.PlanSlugs.basic },
        },
      ],
      counts: {},
      loadingCounts: false,
      selectedPill: this.$route.params.tab || "todos",
    };
  },
  watch: {
    "$route.params"(value) {
      this.selectedPill = value.tab || "todos";
    },
  },
  mounted() {
    this.fetchCounts();
    // Após aprovar/desaprovar um psi a lista dispara isso — recarrega os totais
    this.$eventBus.$on("updatePsiList", () => this.fetchCounts());
  },
  beforeDestroy() {
    this.$eventBus.$off("updatePsiList");
  },
  computed: {
    activePill() {
      return this.pills.find((p) => p.id === this.selectedPill) || this.pills[0];
    },
    // Filtro de data compartilhado por todos os segmentos
    dateFilters() {
      const f = {};
      if (this.customDateFrom) f.date_from = this.customDateFrom;
      if (this.customDateTo) f.date_to = this.customDateTo;
      return f;
    },
    // Vai pra <PsychologistsList> — segmento ativo + data
    activeFilters() {
      return {
        ...this.activePill.filters,
        ...this.dateFilters,
      };
    },
    totalPsiCount() {
      return this.counts.all || 0;
    },
  },
  methods: {
    selectPill(id) {
      if (this.selectedPill === id) return;
      this.selectedPill = id;
      this.$router.push(`${this.$paths.psychologists.list}/${id}`).catch(() => {});
    },
    countFor(pill) {
      const v = this.counts[pill.countKey];
      return v == null ? "…" : v;
    },
    async fetchCounts() {
      this.loadingCounts = true;
      try {
        const res = await this.$dashboardService.psyCounts({
          ...this.dateFilters,
        });
        this.counts = res.data || {};
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingCounts = false;
      }
    },
    dateFilterChanged(value) {
      const today = this.$moment().format("YYYY-MM-DD");
      const yesterday = this.$moment().subtract(1, "days").format("YYYY-MM-DD");
      const last30 = this.$moment().subtract(30, "days").format("YYYY-MM-DD");

      if (value === "hoje") {
        this.customDateFrom = today;
        this.customDateTo = today;
      } else if (value === "ontem") {
        this.customDateFrom = yesterday;
        this.customDateTo = yesterday;
      } else if (value === "ultimos_30_dias") {
        this.customDateFrom = last30;
        this.customDateTo = today;
      } else {
        this.customDateFrom = "";
        this.customDateTo = "";
      }
      // datas mudaram -> recarrega totais dos pills
      this.fetchCounts();
    },
    customDateChanged() {
      this.dateFilter = "";
      this.fetchCounts();
    },
  },
};
